/**
 * @generated SignedSource<<ebcba20243e2dbedbea288182ef8b4bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DownloadPQiFeedbackButton_survey$data = {
  readonly projectRawId: string;
  readonly resultsUnlocked: boolean;
  readonly surveyNumber: number;
  readonly " $fragmentType": "DownloadPQiFeedbackButton_survey";
};
export type DownloadPQiFeedbackButton_survey$key = {
  readonly " $data"?: DownloadPQiFeedbackButton_survey$data;
  readonly " $fragmentSpreads": FragmentRefs<"DownloadPQiFeedbackButton_survey">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DownloadPQiFeedbackButton_survey",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectRawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultsUnlocked",
      "storageKey": null
    }
  ],
  "type": "ProjectSurvey",
  "abstractKey": null
};

(node as any).hash = "915a8856926b43df5e1a324192d80ca3";

export default node;
